import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { X, Calendar } from 'lucide-react';

/**
 * Modal: "Hangi takvime eklemek istiyorsunuz?" – used when user has multiple calendars
 * (event creation from chat or "Katılıyorum" with multiple calendars).
 */
const SelectCalendarModal = ({ isOpen, onClose, calendars = [], onSelect }) => {
  const { t } = useTranslation('calendar');
  if (!isOpen) return null;

  const handleSelect = (calendar) => {
    onSelect?.(calendar);
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100000] flex items-center justify-center p-4 backdrop-blur-sm"
          style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            transition={{ type: 'spring', damping: 20, stiffness: 300 }}
            className="relative bg-[var(--color-bg-elevated)] p-5 rounded-xl shadow-xl border border-white/10 max-w-sm w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={onClose}
              className="absolute top-3 right-3 p-1 rounded-full text-[var(--color-text-muted)] hover:bg-[var(--color-surface-hover)] hover:text-textPrimary transition-colors"
              aria-label={t('selectCalendarModal.close')}
            >
              <X className="w-5 h-5" />
            </button>
            <div className="flex items-center gap-2 mb-4">
              <Calendar className="w-5 h-5 text-[var(--color-text-primary)]" />
              <h3 className="text-lg font-semibold text-[var(--color-text-primary)] dark:text-white">
                {t('selectCalendarModal.title')}
              </h3>
            </div>
            <ul className="space-y-1 max-h-64 overflow-y-auto">
              {calendars.map((cal) => (
                <li key={cal.id}>
                  <button
                    type="button"
                    onClick={() => handleSelect(cal)}
                    className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-left text-[var(--color-text-primary)] dark:text-[var(--color-text-primary)] hover:bg-[var(--color-bg-elevated)] dark:hover:bg-[var(--color-surface-hover)] transition-colors"
                  >
                    <span
                      className="w-4 h-4 rounded-full flex-shrink-0"
                      style={{ backgroundColor: cal.color || '#ffffff' }}
                    />
                    <span className="font-medium truncate">{cal.name || t('selectCalendarModal.defaultName')}</span>
                  </button>
                </li>
              ))}
            </ul>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SelectCalendarModal;
